import { ErrorType } from '../content';

/**
 * Triggers an initialization request to the specified endpoint using a POST request.
 * Sets the job ID and marks initiation as complete if successful.
 * Calls setError if the request fails or returns an error status.
 *
 * @param {Object} params - The initialization configuration.
 * @param {string} params.endpoint - The endpoint to send the POST request to.
 * @param {(value?: ErrorType) => void} params.setError - Callback to invoke on error.
 * @param {(value?: string) => void} params.setJobId - Callback to set the job ID from the response.
 * @param {(value: boolean) => void} params.setInitiated - Callback to mark initiation as complete.
 * @returns {Promise<void>} A promise that resolves when the operation is complete.
 */
export const triggerInit = async ({
  endpoint,
  setError,
  setJobId,
  setInitiated,
}: {
  endpoint: string;
  setError: (value?: ErrorType) => void;
  setJobId: (value?: string) => void;
  setInitiated: (value: boolean) => void;
}) => {
  try {
    await fetch(endpoint, { method: 'POST' })
      .then((response) => {
        if (response.status >= 400) setError('DEFAULT');
        return response.json();
      })
      .then((data) => {
        // Should only ever be jobId, but handle job_id just in case
        if (data?.jobId || data?.job_id) {
          window.vqMetrics.logInitialised({ jobId: data.jobId || data.job_id });
          setJobId(data.jobId || data.job_id);
        }
        setInitiated(true);
      })
      .catch(() => {
        window.vqMetrics.logErrorDisplayed({ errorCode: 'DEFAULT' });
        setError('DEFAULT');
      });
  } catch (err) {
    window.vqMetrics.logErrorDisplayed({ errorCode: 'DEFAULT' });
    setError('DEFAULT');
  }
};
